import { Star, ThumbsUp, Heart, Ban, Send, CheckCircle2 } from "lucide-react";

/**
 * iter105 — Admin-only badge that reflects the current Review / Like / Tip
 * status of a booking. Values:
 *   - not_available: booking not feedback-eligible (pending/unpaid/cancelled/dup/archived)
 *   - not_sent:      eligible, no automated request sent yet
 *   - sent:          automated request delivered to customer (SMS + Email)
 *   - submitted:     customer completed the action
 *
 * Falls back to "not_available" for cancelled / duplicate / archived / non-completed
 * bookings even if a legacy status field lingers on the doc.
 */
const META = {
  review: {
    icon: Star,
    label: "Review",
  },
  like: {
    icon: ThumbsUp,
    label: "Like",
  },
  tip: {
    icon: Heart,
    label: "Tip",
  },
};

const STATE_CLASSES = {
  submitted:     "bg-emerald-100 text-emerald-800 border-emerald-200",
  sent:          "bg-blue-50 text-blue-800 border-blue-200",
  not_sent:      "bg-gray-100 text-gray-700 border-gray-200",
  not_available: "bg-gray-50 text-gray-400 border-gray-200",
};

const STATE_LABELS = {
  submitted: "Submitted",
  sent: "Request Sent",
  not_sent: "Pending",
  not_available: "N/A",
};

export default function FeedbackStatusBadge({ kind, booking }) {
  if (!booking) return null;
  const m = META[kind];
  if (!m) return null;
  const eligible =
    booking.status === "completed" &&
    (booking.payment_status === "paid" || booking.payment_status === "pay_on_arrival") &&
    !booking.duplicate_of_booking_id &&
    !booking.archived_at;

  let state = booking[`${kind}_status`];
  if (!eligible) state = "not_available";
  else if (!state) state = "not_sent";

  const Icon =
    state === "submitted" ? CheckCircle2 :
    state === "sent" ? Send :
    state === "not_available" ? Ban : m.icon;

  return (
    <span
      data-testid={`${kind}-status-${booking.booking_id}-${state}`}
      title={`${m.label}: ${STATE_LABELS[state]}`}
      className={`inline-flex items-center gap-1 text-[10px] font-extrabold uppercase tracking-[0.14em] px-2 py-0.5 rounded-full border ${STATE_CLASSES[state]}`}
    >
      <Icon className="w-3 h-3" /> {m.label} · {STATE_LABELS[state]}
    </span>
  );
}
